/**
 * ⚙️ Configuração de Features do Sistema
 *
 * Centralize aqui todas as flags de features que podem ser ativadas/desativadas
 */

export const FEATURES = {
  /**
   * 🎓 Tutorial de Onboarding
   *
   * Controla se o tutorial interativo será exibido para novos usuários
   *
   * @type {boolean}
   * @default false
   *
   * Como ativar:
   * 1. No arquivo .env, adicione: VUE_APP_ENABLE_TUTORIAL=true
   * 2. Reinicie o servidor de desenvolvimento
   *
   * Quando ativo:
   * - Usuários que nunca completaram o tutorial verão ele ao fazer login
   * - Tutorial tem 4 steps: Buscar, Curtir, Comentar, Perfil
   * - Step de comentário abre post e permite comentário fake (não salva no BD)
   * - Elementos em destaque aparecem com cores originais (sem blur)
   *
   * Quando inativo:
   * - Tutorial nunca será exibido
   * - Campo tutorial_completed no BD continua existindo mas não é usado
   */
  ENABLE_TUTORIAL: process.env.VUE_APP_ENABLE_TUTORIAL === "true",

  /**
   * 📊 Analytics
   * Ativa coleta de dados de uso (quando implementado)
   */
  ENABLE_ANALYTICS: process.env.VUE_APP_ENABLE_ANALYTICS === "true",

  /**
   * 🔔 Notificações Push
   * Ativa notificações push (quando implementado)
   */
  ENABLE_PUSH_NOTIFICATIONS:
    process.env.VUE_APP_ENABLE_PUSH_NOTIFICATIONS === "true",
};

/**
 * Helper para verificar se uma feature está ativa
 */
export function isFeatureEnabled(featureName) {
  return FEATURES[featureName] === true;
}

/**
 * Log de features ativas no console (apenas em desenvolvimento)
 */
if (process.env.NODE_ENV === "development") {
  console.log("🎯 Features Ativas:", {
    Tutorial: FEATURES.ENABLE_TUTORIAL ? "✅ ATIVO" : "❌ INATIVO",
    Analytics: FEATURES.ENABLE_ANALYTICS ? "✅ ATIVO" : "❌ INATIVO",
    "Push Notifications": FEATURES.ENABLE_PUSH_NOTIFICATIONS
      ? "✅ ATIVO"
      : "❌ INATIVO",
  });
}

export default FEATURES;
